'use strict';

var intentionColors = require('../../../../../../../../../../_virtual/intentionColors.cjs');

var hasRequiredIntentionColors;

function requireIntentionColors () {
	if (hasRequiredIntentionColors) return intentionColors.__exports;
	hasRequiredIntentionColors = 1;

	var INTENTION_COLORS = /*#__PURE__*/ function(INTENTION_COLORS) {
	    INTENTION_COLORS["alternate"] = "alternate";
	    INTENTION_COLORS["critical"] = "critical";
	    INTENTION_COLORS["discovery"] = "discovery";
	    INTENTION_COLORS["info"] = "info";
	    INTENTION_COLORS["inverse"] = "inverse";
	    INTENTION_COLORS["neutral"] = "neutral";
	    INTENTION_COLORS["recur"] = "recur";
	    INTENTION_COLORS["smart"] = "smart";
	    INTENTION_COLORS["success"] = "success";
	    INTENTION_COLORS["warning"] = "warning";
	    return INTENTION_COLORS;
	}({});

	intentionColors.__exports.INTENTION_COLORS = INTENTION_COLORS;
	
	return intentionColors.__exports;
}

exports.__require = requireIntentionColors;
//# sourceMappingURL=intentionColors.cjs.map
